// Matches Android logcat timestamp prefix: "MM-DD HH:MM:SS.mmm"
export const LOGCAT_TIMESTAMP_RE = /^\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d+/;

// Matches iOS unified log timestamp prefix: "YYYY-MM-DD HH:MM:SS.microseconds±HHmm"
export const IOS_TIMESTAMP_RE =
  /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d+[+-]\d{4}/;

export const LOGCAT_LEVEL_MAP: Record<string, string> = {
  V: "Verbose",
  D: "Debug",
  I: "Info",
  W: "Warning",
  E: "Error",
  F: "Fatal",
};

// Android logcat: "MM-DD HH:MM:SS.mmm PID TID LEVEL tag: message"
export function parseLogcatMeta(line: string): {
  level: string;
  process: string;
} {
  const tokens = line.split(/\s+/);
  const levelChar = tokens[4];
  if (!LOGCAT_LEVEL_MAP[levelChar]) {
    return { level: "System", process: "-" };
  }
  return {
    level: LOGCAT_LEVEL_MAP[levelChar],
    process: tokens[5] ? tokens[5].replace(/:$/, "") : "-",
  };
}

// iOS unified log: "YYYY-MM-DD HH:MM:SS±TZ  host process[PID]: (subsystem) [category] message"
export function parseIosLineMeta(line: string): {
  level: string;
  process: string;
} {
  const tokens = line.split(/\s+/);
  const process = tokens[3]?.replace(":", "") ?? "-";
  return { level: "System", process };
}

export function parseLineMeta(
  line: string,
  isIos: boolean
): { level: string; process: string; message: string } {
  const { level, process } = isIos
    ? parseIosLineMeta(line)
    : parseLogcatMeta(line);
  const isStructured = isIos
    ? IOS_TIMESTAMP_RE.test(line)
    : LOGCAT_TIMESTAMP_RE.test(line);
  const messageSlice = 6;
  const message = isStructured
    ? line.split(/\s+/).slice(messageSlice).join(" ")
    : line;
  return { level, process, message };
}
